import type { LucideIcon } from 'lucide-react';

export function ComingSoon({ title, phase, description, icon: Icon }: {
  title: string;
  phase: string;
  description: string;
  icon: LucideIcon;
}) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 p-8 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#252D63]/10 text-[#252D63] dark:text-[#51BFAA]">
        <Icon className="h-6 w-6" />
      </div>
      <div>
        <div className="text-2xs uppercase tracking-wide text-muted-foreground">{phase}</div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight">{title}</h1>
      </div>
      <p className="max-w-md text-sm text-muted-foreground">{description}</p>
    </div>
  );
}
